export const CONTACT = {
  phone: "070 0938517",
  phoneHref: "tel:+390700938517",
  whatsapp: "https://wa.me/390700938517",
  email: "info@hairboutiqueshop.it",
  address: "Via delle Serre, 4",
  city: "09044 Quartucciu (CA)",
  mapsQuery: "Via delle Serre 4, 09044 Quartucciu CA",
  treatwell: "https://widget.treatwell.it/salone/100059605/menu/",
  instagram: "https://www.instagram.com/hairboutique_beauty/",
  instagramBarber: "https://www.instagram.com/hairboutique_barber/",
  facebook: "https://www.facebook.com/profile.php?id=61555686729980&locale=it_IT",
  hours: [
    ["Martedì – Sabato", "9:00 – 18:00"],
    ["Orario continuato", "senza pausa"],
    ["Domenica e lunedì", "Chiuso"],
  ],
};

export const NAV = [
  ["servizi", "Servizi"],
  ["sposa", "Sposa"],
  ["listino", "Listino"],
  ["galleria", "Galleria"],
  // ["team", "Team"], // riattiva quando le foto team sono pronte
  ["prenota", "Prenota"],
  ["contatti", "Contatti"],
];

export const SERVICES = [
  {
    id: "taglio-donna",
    no: "01",
    title: "Taglio donna",
    accent: "& Styling",
    text: "Un taglio pensato sul tuo viso e sul tuo modo di vivere i capelli, rifinito con una piega che dura.",
    img: "/img/ig-donna.jpg",
    span: "lg:col-span-7 lg:row-span-2",
  },
  {
    id: "hair-color",
    no: "02",
    title: "Hair color",
    accent: "& schiariture",
    text: "Colpi di sole, riflessi e colori decisi, luminosi e brillanti.",
    img: "/img/ig-colore.jpg",
    span: "lg:col-span-5",
  },
  {
    id: "hair-spa",
    no: "03",
    title: "Hair Spa",
    accent: "& Olaplex",
    text: "Trattamenti per cute e capello che ricostruiscono, nutrono e restituiscono morbidezza.",
    img: "/img/ig-spa.jpg",
    span: "lg:col-span-5",
  },
  {
    id: "taglio-uomo",
    no: "04",
    title: "Taglio uomo",
    accent: "& barba",
    text: "Sfumature precise, barba definita, uno stile curato in ogni dettaglio.",
    img: "/img/ig-uomo.jpg",
    span: "lg:col-span-5",
  },
];

export const PRICES = [
  ["Taglio donna", "Taglio, frangia e rifiniture", "da € 32"],
  ["Taglio uomo", "Forbice e sfumature", "da € 15"],
  ["Barba", "Modellatura e rifinitura", "€ 7"],
  ["Taglio bambini", "Per i più giovani", "da € 14"],
  ["Piega", "Liscia, mossa, onde", "da € 22"],
  ["Schiariture", "Colpi di sole, degradé e riflessi", "da € 100"],
  ["Trattamenti cute e capello", "Ricostruzione e nutrimento", "da € 3"],
  ["Nanoplastia", "Lisciature e stiratura capelli", "da € 200"],
  ["Extension capelli", "Volume e lunghezza", "€ 4 a ciocca"],
];

export const GALLERY = [
  { src: "/img/ig-sposa.jpg", label: "Look cerimonia", tag: "Sposa & make-up" },
  { src: "/img/gallery-manic-1.jpg", label: "Direction Color — Manic Panic", tag: "Crazy color" },
  { src: "/img/gallery-manic-2.jpg", label: "Direction Color — Manic Panic", tag: "Crazy color" },
  { src: "/img/gallery-manic-3.jpg", label: "Direction Color — Manic Panic", tag: "Crazy color" },
  { src: "/img/gallery-vanilla-1.jpg", label: "Vanilla balayage", tag: "Balayage" },
  { src: "/img/gallery-vanilla-2.jpg", label: "Vanilla balayage", tag: "Balayage" },
  { src: "/img/gallery-copper-degrade.jpg", label: "Intense copper degradé", tag: "Balayage" },
  { src: "/img/ig-uomo2.jpg", label: "Classic side part", tag: "Barber" },
  { src: "/img/ig-makeup.jpg", label: "Divina", tag: "Make-up" },
  { src: "/img/gallery-cherry.jpg", label: "Cherry balayage", tag: "Balayage" },
];

export const TEAM = [
  { name: "Alessandro", role: "Barber", img: null },
  { name: "Valentina", role: "Specialista schiariture & crazy color", img: null },
  { name: "Manuela", role: "Hairstylist & Make-up artist", img: null },
  { name: "Veronica", role: "Hairstylist & Make-up artist", img: null },
];

export const MARQUEE = [
  "Taglio donna", "Olaplex", "Hair color", "Lisap", "Taglio uomo & barba",
  "ghd", "Sposa", "Johnny Verax Professional", "Degradè & Balayage", "Olaplex", "Make-up", "Lisap", "Nanoplastia", "ghd",
];

export const SERVICE_OPTIONS = [
  "Taglio donna & styling",
  "Hair color & schiariture",
  "Hair Spa & Olaplex",
  "Taglio uomo & barba",
  "Sposa & cerimonia",
  "Make-up",
  "Piega",
  "Extension",
  "Altro / consulenza",
];
